import { apiFetch } from './client';

export type CheckoutSessionResponse = {
  ok?: boolean;
  status?: string;
  upgrade?: string;
  error?: string;
};

export async function postBillingCheckoutSession(): Promise<CheckoutSessionResponse> {
  return apiFetch<CheckoutSessionResponse>('/billing/checkout-session', {
    method: 'POST',
    body: {},
  });
}
